import createLucideIcon from '../createLucideIcon';
import { IconNode } from '../types';

export const __iconNode: IconNode = [
  ['path', { d: 'M12 12H5a2 2 0 0 0-2 2v5', key: '7zsz91' }],
  ['path', { d: 'M15 19h7', key: '1askl3' }],
  ['path', { d: 'M16 19V2', key: '1gf9nk' }],
  [
    'path',
    {
      d: 'M6 12V7a2 2 0 0 1 2-2h2.172a2 2 0 0 1 1.414.586l3.828 3.828A2 2 0 0 1 16 10.828',
      key: 'enx9tf',
    },
  ],
  ['path', { d: 'M7 19h4', key: 'fumhkk' }],
  ['circle', { cx: '13', cy: '19', r: '2', key: 'wjnkru' }],
  ['circle', { cx: '5', cy: '19', r: '2', key: 'v8kfzx' }],
];

/**
 * @component @name Forklift
 * @description Lucide SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTIgMTJINWEyIDIgMCAwIDAtMiAydjUiIC8+CiAgPHBhdGggZD0iTTE1IDE5aDciIC8+CiAgPHBhdGggZD0iTTE2IDE5VjIiIC8+CiAgPHBhdGggZD0iTTYgMTJWN2EyIDIgMCAwIDEgMi0yaDIuMTcyYTIgMiAwIDAgMSAxLjQxNC41ODZsMy44MjggMy44MjhBMiAyIDAgMCAxIDE2IDEwLjgyOCIgLz4KICA8cGF0aCBkPSJNNyAxOWg0IiAvPgogIDxjaXJjbGUgY3g9IjEzIiBjeT0iMTkiIHI9IjIiIC8+CiAgPGNpcmNsZSBjeD0iNSIgY3k9IjE5IiByPSIyIiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/forklift
 * @see https://lucide.dev/guide/packages/lucide-vue-next - Documentation
 *
 * @param {Object} props - Lucide icons props and any valid SVG attribute
 * @returns {FunctionalComponent} Vue component
 *
 */
const Forklift = createLucideIcon('forklift', __iconNode);

export default Forklift;
